(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8573],{

/***/ 97163:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/500",
      function () {
        return __webpack_require__(57776);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Custom500; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/Shared/ErrorBoundary/index.module.scss
var index_module = __webpack_require__(96228);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/Shared/ErrorBoundary/GenericError.jsx



const GenericError = (props)=>{
    const { msg =""  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).genericErrorWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
            children: msg ? msg : constants["default"].ERROR_MESSAGE.GENERAL
        })
    });
};
/* harmony default export */ var ErrorBoundary_GenericError = (GenericError);

// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
;// CONCATENATED MODULE: ./pages/500.jsx




var __N_SSG = true;
/**
 *
 * @return {JSX.Element}
 */ function Custom500(param) {
    let { headertmp: header , footertmp: footer  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            header ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader["default"], {
                header: header
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary_GenericError, {}),
            footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter["default"], {
                footer: footer
            }) : null
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(97163); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);